module.exports = __webpack_public_path__ + "img/evoker.99fbd27f.jpg";